export default {"src":"/_next/static/media/404.6c5312c6.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};